import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["tableComponent", "topRow", "bottomRow", "customStrings"],
      _excluded2 = ["footer"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useRef } from "react";
import { EXPANDABLE_COLUMN_KEY, ROW_NUMBER_COLUMN_KEY, SELECTABLE_COLUMN_KEY } from "../constants";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const TableFooterRow = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    tableComponent: TableComponent,
    topRow,
    bottomRow,
    customStrings
  } = props,
        tableProps = _objectWithoutProperties(props, _excluded);

  const internalRef = useRef();
  const tableRef = ref || internalRef;
  const footerRows = [];
  const isFooterColumnsExist = Boolean(topRow && topRow.footerColumns);
  /**
   * Returns the columns key array.
   * @return {Array}
   */

  const getColumnsKey = columns => columns.map(function (col) {
    return col.key;
  });
  /**
   * Returns the columns array for the footer.
   * @return {Array}
   */


  const getFooterColumns = props => {
    const {
      columns,
      topRow
    } = props;
    const {
      footerColumns
    } = topRow;
    const tableColArray = getColumnsKey(columns);
    const footerColArray = getColumnsKey(footerColumns);
    const footerArray = [];
    let index = 0,
        j;
    /**
     * Generating the final footer column array, based on the table and footer columns.
     */

    tableColArray.forEach(function (value, index) {
      const footerColIndex = footerColumns[footerColArray.indexOf(value)];

      if (footerColArray.indexOf(value) !== -1) {
        footerArray[index] = footerColIndex;
      } else {
        footerArray[index] = {
          key: tableColArray[index]
        };
      }
    });
    const footerArrLength = footerArray.length;

    for (j = 0; j < footerArrLength; j++) {
      const key = footerArray[j].key;
      /* Calculate the index, based on the plugins. */

      if (key === ROW_NUMBER_COLUMN_KEY || key === SELECTABLE_COLUMN_KEY || key === EXPANDABLE_COLUMN_KEY) {
        index = j + 1;
      }
    }
    /**
     * The colspan attribute applied to the first column.
     * The next colspan - 1 column will NOT be rendered.
     */


    if (topRow.heading) {
      const heading = topRow.heading;
      const colspan = heading.colspan || 1; // Passing colspan property to fist item

      /* istanbul ignore else */

      if (footerArray[index]) {
        footerArray[index].colspan = colspan;
        footerArray[index].className = heading.className;
        footerArray.splice(index + 1, colspan - 1);
      }
    }

    return footerArray;
  };

  if (isFooterColumnsExist) {
    const footerColumns = getFooterColumns(props);
    footerRows.push(_objectSpread(_objectSpread({}, topRow), {}, {
      footerColumns
    }));
  }

  bottomRow && footerRows.push(bottomRow);
  return _jsx(TableComponent, _objectSpread(_objectSpread({}, tableProps), {}, {
    footerRows: footerRows,
    customStrings: customStrings,
    ref: tableRef
  }));
});
/**
 * A higher-order component that will return a TableFooterRow component
 * which will internally use the passed Table class argument as the React element.
 * @param  {React.Element} TableComponent The Table component or another wrapped
 * Table component.
 * @return {Function} A Functional component that will enhance
 * TableComponent.
 */

function withFooterRow(TableComponent) {
  const WrappedTable = /*#__PURE__*/React.forwardRef((props, ref) => {
    const {
      footer
    } = props,
          others = _objectWithoutProperties(props, _excluded2); // eslint-disable-line no-unused-vars


    if (footer) {
      const footerProps = Object.assign({}, footer);
      return _jsx(TableFooterRow, _objectSpread(_objectSpread({
        tableComponent: TableComponent
      }, footerProps), {}, {
        ref: ref
      }, others));
    } else {
      return _jsx(TableComponent, _objectSpread(_objectSpread({}, others), {}, {
        ref: ref
      }));
    }
  });
  WrappedTable.displayName = `withFooterRow(${TableComponent.displayName || TableComponent.name})`;
  return WrappedTable;
}

export default withFooterRow;